{
  "version": 1,
  "asset_id": "e48f60a7-17a0-4e4f-b4f4-c42056653ad8",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/e48f60a7-17a0-4e4f-b4f4-c42056653ad8/ss01-card-p1.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/e48f60a7-17a0-4e4f-b4f4-c42056653ad8/ss01-card-p1.webp",
  "original_filename": "ss01-card-p1.webp",
  "size": 119532,
  "content_type": "image/webp",
  "created_at": "2026-09-12T16:22:45Z"
}
